import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import {
  useGetSettingQuery,
  useUpdateSettingMutation,
} from 'store/api/yay/user'
import {
  selectSettingsForGroups,
  setSettingsForGroups,
} from 'store/slices/settings'
import { useLogEventTimelineFilter } from '../TimelineFilterModal'
import { logEvent } from 'lib/analytics'
import { toBooleanString } from 'lib/helpers'

import { Link } from 'features/i18n/router'
import { SettingItem, Switch } from 'components'

const AllGroupsSettingsModal = ({ location }) => {
  const { t } = useTranslation()
  useLogEventTimelineFilter()

  const { data, isFetching } = useGetSettingQuery()
  const { hideRepliesOnTimeline } = useSelector(selectSettingsForGroups)
  const dispatch = useDispatch()
  const [updateSetting, updateSettingRes] = useUpdateSettingMutation()

  return (
    <div className="Modal__wrapper AllGroupsSettingsModal">
      <div className="Modal__header">
        <Link className="Modal__header__close" to={location.pathname} />

        <h2 className="Modal__header__h2">{t('groups.settings')}</h2>
      </div>

      <div className="Modal__body">
        <h3 className="TextSectionTitle">{t('common.invitation')}</h3>
        <SettingItem
          label={t('user_setting.privacy.invite_only_followings_group')}
        >
          <Switch
            checked={data?.setting?.following_only_group_invite}
            disabled={isFetching || updateSettingRes?.isLoading}
            onChange={(c) => {
              updateSetting({ mode: 'following_only_group_invite', on: c })
            }}
          />
        </SettingItem>

        <h3 className="TextSectionTitle">{t('common.timeline')}</h3>
        <SettingItem label={t('groups.settings.hide_replies_on_timeline')}>
          <Switch
            checked={hideRepliesOnTimeline}
            onChange={(c) => {
              dispatch(
                setSettingsForGroups({ key: 'hideRepliesOnTimeline', value: c })
              )
              logEvent.timeline_filter_update({
                no_reply_group_timeline: toBooleanString(c),
                origin: 'timeline',
              })
            }}
          />
        </SettingItem>
      </div>
    </div>
  )
}

export default AllGroupsSettingsModal
